var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.wrapperClass},[(!_vm.loadedComponent || _vm.loading)?_c('PlaceholderBox'):_vm._e(),_c(_vm.loadedComponent,_vm._g(_vm._b({ref:"loadedComponent",tag:"component",class:{ 'd-none': _vm.loading }},'component',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }